import { singularityStore } from "@/store/store";
import { getPagesFromWPAndPlaceInStore } from "./wp-page-manager/pages";

export function setUi(step: "step1" | "step2" | "step3" | "step4" | "step5") {
  switch (step) {
    case "step1":
      setUiForStep1();
      break;
    case "step2":
      setUiForStep2();
      break;
    case "step3":
      break;
  }
}

function setUiForStep1() {
  singularityStore.setSingularityUiState({
    singularityFullWidthPanel: "step1",
    singularityLeftPanel: null,
    singularityRightPanel: null
  });
}

function setUiForStep2() {
  getPagesFromWPAndPlaceInStore();
  singularityStore.setSingularityUiState({
    singularityFullWidthPanel: null,
    singularityLeftPanel: "page_structure",
    singularityRightPanel: null
  });

  // Update URL to reflect step2 and remove autostart parameter
  const url = new URL(window.location.href);
  url.searchParams.set("singularity", "step2");
  url.searchParams.delete("autostart");
  window.history.replaceState({}, "", url.toString());
}
